import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export type Project = {
	id: string;
	key: string;
	projectTypeKey: 'customer_service';
	permissions: {
		canEdit: boolean;
	};
};

const getData = async () => {
	try {
		const v2projects =
			'/rest/api/2/project/search?maxResults=100&typeKey=customer_service&expand=permissions';

		// we check for browse access, which means user must be part of the project.
		// jira admin can Administer projects without being part of the actual project.
		// see https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-projects/#api-rest-api-3-project-search-get
		const v3projects =
			'/rest/api/3/project/search?expand=permissions&typeKey=customer_service&action=browse&maxResults=100&startAt=0';

		const data = await fetchJson<{ values: Project[] }>(
			fg('berry-6701-avoid-404-for-jiraadmin') ? v3projects : v2projects,
		);

		const projectWhereAdmin = data?.values?.find((project) => project.permissions.canEdit);

		// includes collaborator
		// collaborator will get 403 on customers and organizations list pages
		const projectWhereUser = data?.values?.find((project) => !project.permissions.canEdit);

		return projectWhereAdmin || projectWhereUser || null;
	} catch (error) {
		fireErrorAnalytics({
			meta: {
				id: 'l1CustomersProjectProvider',
				packageName: 'jiraRouterResourcesCustomerServiceL1CustomersProjectProvider',
				teamName: 'Boysenberry',
			},
			error: error instanceof Error ? error : undefined,
		});

		throw error;
	}
};

export default getData;
